type Props = {
  height: number | string
  width: number | string
}
export const AzeroIDLogo: React.FC<Props> = ({ height, width }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={`${width}`} height={`${height}`} viewBox="0 0 512 512" fill="none">
    <g clipPath="url(#clip0_223_447)">
      <path
        d="M256.537 437.054C171.687 437.054 100.549 377.685 81.6771 298.18C81.1611 296.107 79.3182 294.553 77.1803 294.553H11.7184C8.84334 294.553 6.55807 297.218 7.0741 300.105C27.789 419.584 131.658 510.784 256.537 510.784C381.416 510.784 485.286 419.584 506 300.105C506.516 297.218 504.231 294.553 501.356 294.553H435.894C433.756 294.553 431.913 296.033 431.397 298.18C412.525 377.685 341.387 437.054 256.537 437.054Z"
        fill="currentColor"
      />
      <path
        d="M256.537 75.7304C341.387 75.7304 412.525 135.1 431.397 214.604C431.913 216.677 433.756 218.231 435.894 218.231H501.356C504.231 218.231 506.516 215.567 506 212.679C485.211 93.2007 381.342 2 256.537 2C131.731 2 27.7885 93.2007 6.99988 212.679C6.48385 215.567 8.76912 218.231 11.6441 218.231H77.1798C79.3177 218.231 81.1606 216.751 81.6766 214.604C100.549 135.1 171.687 75.7304 256.537 75.7304Z"
        fill="currentColor"
      />
      <path
        d="M256.537 204.685C240.319 204.685 225.796 212.235 216.36 224.08C209.283 232.963 205.008 244.141 205.008 256.429C205.008 268.718 209.283 279.896 216.36 288.779C225.796 300.549 240.245 308.174 256.537 308.174C272.829 308.174 287.278 300.623 296.714 288.779C303.79 279.896 308.066 268.718 308.066 256.429C308.066 244.141 303.79 232.963 296.714 224.08C287.278 212.309 272.829 204.685 256.537 204.685Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_223_447">
        <rect width="499" height="508.784" fill="white" transform="translate(7 2)" />
      </clipPath>
    </defs>
  </svg>
)
